module.exports = __webpack_public_path__ + "static/media/img31.34e6f351.JPG";